import { Box, styled, Typography } from '@mui/material';

export const styledUpdateDrawer = {
  container: styled(Box)(({ theme }) => ({
    width: '450px',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100vh',
    [theme.breakpoints.down('mobile')]: {
      width: '100%',
    },
  })),
  header: styled(Typography)(({ theme }) => ({
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    padding: '21px 24px',
    fontWeight: '700',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  })),
  content: styled(Box)(() => ({
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    height: '100vh',
    fontSize: '18px',
  })),
};
